/**
 * @generated SignedSource<<8bd726a9e54a6b140d4574224a9fa6b8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "FAVOURITED_DATE_ASC" | "FAVOURITED_DATE_DESC" | "NAME_ASC" | "NAME_DESC";
export type GoalScoringMode = "OKR" | "SIMPLE";
export type GoalDirectoryQuery$variables = {
  aaid?: string | null;
  containerId?: string | null;
  favouriteViewsFirst: number;
  favouriteViewsSort?: ReadonlyArray<DirectoryViewSortEnum | null> | null;
  favouriteViewsTql: string;
  includeArchived: boolean;
  newGoalFilterResolversEnabled: boolean;
  workspaceId: string;
  workspaceUuid?: string | null;
};
export type GoalDirectoryQuery$data = {
  readonly customFieldDefinitionTql: {
    readonly " $fragmentSpreads": FragmentRefs<"buildCustomFieldResolvers">;
  } | null;
  readonly customfieldHeaderSupport: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalDirectoryHeaderColumns">;
  } | null;
  readonly favouriteDirectoryViews: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isDefault: boolean | null;
        readonly uuid: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly hasGoals: {
    readonly hasRecords: boolean;
  } | null;
  readonly reportingLines: {
    readonly managers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly peers: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
    readonly reports: ReadonlyArray<{
      readonly __typename: "ReportingLinesUser";
    } | null> | null;
  } | null;
  readonly workspace?: {
    readonly goalScoringMode: GoalScoringMode;
  } | null;
};
export type GoalDirectoryQuery = {
  response: GoalDirectoryQuery$data;
  variables: GoalDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsFirst"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsSort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "favouriteViewsTql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newGoalFilterResolversEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "args": [
    {
      "kind": "Variable",
      "name": "aaidOrHash",
      "variableName": "aaid"
    }
  ],
  "concreteType": "ReportingLines",
  "kind": "LinkedField",
  "name": "reportingLines",
  "plural": false,
  "selections": [
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "managers",
      "plural": true,
      "selections": (v10/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "peers",
      "plural": true,
      "selections": (v10/*: any*/)
    },
    {
      "concreteType": "ReportingLinesUser",
      "kind": "LinkedField",
      "name": "reports",
      "plural": true,
      "selections": (v10/*: any*/)
    }
  ]
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "goalScoringMode"
},
v14 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v15 = {
  "args": [
    (v14/*: any*/),
    {
      "kind": "Variable",
      "name": "includeArchived",
      "variableName": "includeArchived"
    },
    {
      "kind": "Variable",
      "name": "workspaceId",
      "variableName": "workspaceId"
    }
  ],
  "concreteType": "HasRecords",
  "kind": "LinkedField",
  "name": "hasGoals",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRecords"
    }
  ]
},
v16 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v17 = [
  (v14/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "(entityType = GOAL AND (type != String OR hasPredefinedValues = true))"
  },
  (v16/*: any*/)
],
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "token"
},
v20 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v21 = {
  "kind": "ScalarField",
  "name": "value"
},
v22 = [
  (v14/*: any*/),
  {
    "kind": "Literal",
    "name": "q",
    "value": "entityType = GOAL"
  },
  (v16/*: any*/)
],
v23 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "favouriteViewsFirst"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "favouriteViewsTql"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "favouriteViewsSort"
  },
  (v16/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v25 = {
  "kind": "ScalarField",
  "name": "isDefault"
},
v26 = {
  "kind": "ScalarField",
  "name": "id"
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    (v26/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = [
  (v24/*: any*/),
  (v18/*: any*/),
  (v28/*: any*/)
],
v30 = [
  (v24/*: any*/),
  (v18/*: any*/),
  (v28/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v11/*: any*/),
      {
        "condition": "newGoalFilterResolversEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v13/*: any*/)
            ]
          }
        ]
      },
      (v15/*: any*/),
      {
        "args": (v17/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "buildCustomFieldResolvers",
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_userResolver",
                            "selections": [
                              (v9/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "UserCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_textSelectResolver",
                            "selections": [
                              (v9/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "concreteType": "CustomFieldTextAllowedValueConnection",
                                "kind": "LinkedField",
                                "name": "allowedValues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v21/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "TextSelectCustomFieldDefinition"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "buildCustomFieldResolvers_numberResolver",
                            "selections": [
                              (v9/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/)
                            ],
                            "argumentDefinitions": []
                          }
                        ],
                        "type": "NumberCustomFieldDefinition"
                      }
                    ]
                  }
                ]
              }
            ],
            "argumentDefinitions": []
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v22/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalDirectoryHeaderColumns"
          }
        ]
      },
      {
        "alias": "favouriteDirectoryViews",
        "args": (v23/*: any*/),
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "directoryViewTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalDirectoryQuery",
    "selections": [
      (v11/*: any*/),
      (v15/*: any*/),
      {
        "args": (v17/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "type": "UserCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "concreteType": "CustomFieldTextAllowedValueConnection",
                        "kind": "LinkedField",
                        "name": "allowedValues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldTextAllowedValueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextAllowedValueNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ],
                    "type": "NumberCustomFieldDefinition"
                  },
                  (v27/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "customfieldHeaderSupport",
        "args": (v22/*: any*/),
        "concreteType": "CustomFieldDefinitionConnection",
        "kind": "LinkedField",
        "name": "customFieldDefinitionTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFieldDefinitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v29/*: any*/),
                    "type": "NumberCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v29/*: any*/),
                    "type": "TextCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v30/*: any*/),
                    "type": "TextSelectCustomFieldDefinition"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v30/*: any*/),
                    "type": "UserCustomFieldDefinition"
                  },
                  (v27/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "favouriteDirectoryViews",
        "args": (v23/*: any*/),
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "directoryViewTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "newGoalFilterResolversEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v26/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e67bc63f573726aa904f84950e5e8ffd",
    "id": null,
    "metadata": {},
    "name": "GoalDirectoryQuery",
    "operationKind": "query",
    "text": "query GoalDirectoryQuery(\n  $aaid: String\n  $workspaceId: ID!\n  $workspaceUuid: UUID\n  $containerId: String\n  $newGoalFilterResolversEnabled: Boolean!\n  $includeArchived: Boolean!\n  $favouriteViewsTql: String!\n  $favouriteViewsFirst: Int!\n  $favouriteViewsSort: [DirectoryViewSortEnum]\n) {\n  reportingLines(aaidOrHash: $aaid) {\n    managers {\n      __typename\n    }\n    peers {\n      __typename\n    }\n    reports {\n      __typename\n    }\n  }\n  workspace(id: $workspaceId) @include(if: $newGoalFilterResolversEnabled) {\n    goalScoringMode\n    id\n  }\n  hasGoals(includeArchived: $includeArchived, workspaceId: $workspaceId, containerId: $containerId) {\n    hasRecords\n  }\n  customFieldDefinitionTql(q: \"(entityType = GOAL AND (type != String OR hasPredefinedValues = true))\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...buildCustomFieldResolvers\n  }\n  customfieldHeaderSupport: customFieldDefinitionTql(q: \"entityType = GOAL\", workspaceUuid: $workspaceUuid, containerId: $containerId) {\n    ...GoalDirectoryHeaderColumns\n  }\n  favouriteDirectoryViews: directoryViewTql(q: $favouriteViewsTql, first: $favouriteViewsFirst, workspaceUuid: $workspaceUuid, containerId: $containerId, sort: $favouriteViewsSort) {\n    edges {\n      node {\n        uuid\n        isDefault\n        id\n      }\n    }\n  }\n}\n\nfragment GoalDirectoryHeaderColumns on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on NumberCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextCustomFieldDefinition {\n        uuid\n        name\n        type\n      }\n      ... on TextSelectCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on UserCustomFieldDefinition {\n        uuid\n        name\n        type\n        canSetMultipleValues\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on UserCustomFieldDefinition {\n        ...buildCustomFieldResolvers_userResolver\n      }\n      ... on TextSelectCustomFieldDefinition {\n        ...buildCustomFieldResolvers_textSelectResolver\n      }\n      ... on NumberCustomFieldDefinition {\n        ...buildCustomFieldResolvers_numberResolver\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_numberResolver on NumberCustomFieldDefinition {\n  __typename\n  name\n  token\n}\n\nfragment buildCustomFieldResolvers_textSelectResolver on TextSelectCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n  allowedValues {\n    edges {\n      node {\n        value\n        id\n      }\n    }\n  }\n}\n\nfragment buildCustomFieldResolvers_userResolver on UserCustomFieldDefinition {\n  __typename\n  name\n  token\n  canSetMultipleValues\n}\n"
  }
};
})();

(node as any).hash = "3c6a55cebdabd505bfa8ceb58cf03ae7";

export default node;
